import { createVideoContentVideos } from '../store/actions/videoContentVideosActions';

export default {
  getURL: 'composeExperienceUrl',
  canOpen: false,
  isSelectable: true,
  // createURL: 'appId/areaId/appContent',
  // sessionParams: ['appId', 'areaId'],
  fields: [
    {
      width: '18rem',
      attributeName: 'composeExperience',
      helpText: 'Title of the video.',
      label: 'Media Name',
      canFilter: true,
    },
    {
      width: '24rem',
      attributeName: 'url',
      helpText: 'Title of the video.',
      label: 'Url',
      canFilter: true,
    },
    {
      width: '20rem',
      attributeName: 'video_type',
      helpText: 'Type of the video.',
      label: 'Video Type',
      canFilter: true,
    },
    {
      width: '20rem',
      attributeName: 'duration',
      helpText: 'Duration of the video.',
      label: 'Duration',
      canFilter: true,
    },
    {
      width: '20rem',
      attributeName: 'eventDate',
      helpText: 'Event date of the video.',
      label: 'Event Date',
      canFilter: true,
    },
  ],
};
